"use client";

import Script from "next/script";
import React from "react";

interface LeadFormPluginScriptProps {
  salt: string;
  onLoad: () => void;
}

export const LeadFormPluginScript: React.FC<LeadFormPluginScriptProps> = ({ salt, onLoad }) => {
  return (
    <Script
      id={`lead-form-plugin-${salt}`}
      src="https://prospect-form-plugin.2u.com/latest/lead.form.plugin.js"
      onLoad={onLoad}
    />
  );
};
